import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const faqData = [
  {
    question: "faq.themeDifference",
    answer: "faq.themeDifferenceAnswer",
  },
  {
    question: "faq.supportsPlugins",
    answer: "faq.supportsPluginsAnswer",
  },
  {
    question: "faq.moneybackGuarantee",
    answer: "faq.moneybackGuaranteeAnswer",
  },
  {
    question: "faq.paymentMethods",
    answer: "faq.paymentMethodsAnswer",
  },
  {
    question: "faq.refundSatisfaction",
    answer: "faq.refundSatisfactionAnswer",
  },
  {
    question: "faq.supportMethods",
    answer: "faq.supportMethodsAnswer",
  },
];

export default function FAQ() {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="dark:bg-black bg-gray-50 w-full py-12 pt-24 lg:py-24">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="mt-12 dark:text-white text-3xl font-bold leading-tight text-gray-900 sm:text-4xl lg:text-5xl">
            {t("faq.title")}
          </h2>
          <p className="dark:text-zinc-400 mt-4 text-base leading-7 text-gray-600">
            {t("faq.subtitle")}
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="dark:border-none dark:bg-slate-900 relative bg-white border border-gray-200 rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <button
                className="flex justify-between items-center w-full p-6 text-left"
                onClick={() => toggleQuestion(index)}
              >
                <span className="font-medium dark:text-white text-gray-900">
                  {t(faq.question)}
                </span>
                <FontAwesomeIcon
                  icon={activeIndex === index ? faMinus : faPlus}
                  className="text-[#00A8E8] w-5 h-5"
                />
              </button>
              {activeIndex === index && (
                <div className="p-6 pt-0">
                  <p className="dark:text-zinc-400 text-gray-600">
                    {t(faq.answer)}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
